import { Box } from '@mui/material';
import { QuestionnaireFormData } from '@/features/questionnaires/types/questionnaire.interface';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NumberInput, TextInput } from '@/shared';

export const NumberQuestionParameters = ({
  questionIndex,
}: {
  questionIndex: number;
}) => {
  const { t } = useTranslation();
  const form = useFormContext<QuestionnaireFormData>();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <NumberInput
          form={form}
          name={`questions.${questionIndex}.parameters.min`}
          sx={{ mt: 1 }}
          label={t('numberQuestionParameters.labels.min')}
          onChange={() =>
            form.trigger(`questions.${questionIndex}.parameters.max`)
          }
        />
        <NumberInput
          form={form}
          name={`questions.${questionIndex}.parameters.max`}
          sx={{ mt: 1 }}
          label={t('numberQuestionParameters.labels.max')}
          onChange={() =>
            form.trigger(`questions.${questionIndex}.parameters.min`)
          }
        />
        <TextInput
          form={form}
          name={`questions.${questionIndex}.parameters.unit`}
          sx={{ mt: 1 }}
          label={t('numberQuestionParameters.labels.unit')}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <NumberInput
          form={form}
          name={`questions.${questionIndex}.parameters.decimalPlaces`}
          sx={{ mt: 1 }}
          label={t('numberQuestionParameters.labels.decimalPlaces')}
        />

        <NumberInput
          form={form}
          name={`questions.${questionIndex}.parameters.defaultValue`}
          sx={{ mt: 1 }}
          label={t('numberQuestionParameters.labels.defaultValue')}
        />
      </Box>
    </Box>
  );
};
